
// import React, { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import Service from "../../services/service";
// import { globalStore } from "../../stores/globalStore";
// import loginLogo from "../../assets/Images/loginLogo.png";
// import google from "../../assets/Images/googleLogo.png";
// import "./SignUp.css";
// import { showSuccessToast, showErrorToast } from "utils/toastNotification";
// import { auth, googleProvider, signInWithPopup } from "utils/firebase";
// import { Spin } from "antd";
// import { FcGoogle } from "react-icons/fc";

// const SignUp = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);

//   const handleGoogleLogin = async () => {
//     setLoading(true);
//     try {
//       const result = await signInWithPopup(auth, googleProvider);
//       const user = result.user;

//       // Extract email properly
//       const email =
//         user.email ||
//         result.providerData?.[0]?.email ||
//         result._tokenResponse?.email ||
//         null;

//       if (!email) {
//         showErrorToast("Unable to retrieve email from Google account");
//         setLoading(false);
//         return;
//       }

//       const payload = {
//         googleId: user.uid,
//         email: email,
//         displayName: user.displayName || email.split('@')[0],
//         image: user.photoURL || "",
//         fcmToken: "fcm-token",
//       };

//       console.log("Final Payload:", payload);

//       const response = await Service.GoogleLogin(payload);

//       if (response && response.data) {
//         localStorage.setItem("authToken", response.data.token);
//         localStorage.setItem("userEmail", email);
//         localStorage.setItem("userName", user.displayName || email.split('@')[0]);
        
//         showSuccessToast("Google login successful!");
        
//         // Redirect to home page after successful login
//         setTimeout(() => {
//           navigate("/");
//         }, 1000);
//       } else {
//         showErrorToast("Login failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error during Google login:", error);
      
//       // Handle specific Firebase errors
//       if (error.code === 'auth/popup-closed-by-user') {
//         showErrorToast("Login cancelled. Please try again.");
//       } else if (error.code === 'auth/popup-blocked') {
//         showErrorToast("Popup blocked. Please allow popups for this site.");
//       } else if (error.code === 'auth/network-request-failed') {
//         showErrorToast("Network error. Please check your connection.");
//       } else {
//         showErrorToast("Failed to login with Google. Please try again.");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="signup-container">
//       <div className="signup-card">
//         <div className="signup-logo-section">
//           <img src={loginLogo} alt="Vers Attire Logo" className="signup-logo" />
//         </div>
        
//         <div className="signup-content">
//           <h1 className="signup-header">Welcome Back!</h1>
//           <p className="signup-subheader">Sign in to continue shopping</p>
          
//           <button 
//             className="signup-google-button" 
//             onClick={handleGoogleLogin}
//             disabled={loading}
//           >
//             {loading ? (
//               <Spin size="small" />
//             ) : (
//               <>
//                 <FcGoogle className="signup-google-icon" />
//                 <span>Continue with Google</span>
//               </>
//             )}
//           </button>

//           <div className="signup-divider">
//             <span className="divider-line"></span>
//             <span className="divider-text">Secure Login</span>
//             <span className="divider-line"></span>
//           </div>

//           <div className="signup-features">
//             <div className="feature-item">
//               <span className="feature-icon">✓</span>
//               <span>Fast & Secure Checkout</span>
//             </div>
//             <div className="feature-item">
//               <span className="feature-icon">✓</span>
//               <span>Order Tracking</span>
//             </div>
//             <div className="feature-item">
//               <span className="feature-icon">✓</span>
//               <span>Exclusive Offers</span>
//             </div>
//           </div>

//           <p className="signup-terms">
//             By continuing, you agree to Vers Attire's{" "}
//             <Link to="/terms" className="signup-link">
//               Terms of Service
//             </Link>{" "}
//             and{" "}
//             <Link to="/privacy" className="signup-link">
//               Privacy Policy
//             </Link>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUp;

import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Service from "../../services/service";
import { globalStore } from "../../stores/globalStore";
import loginLogo from "../../assets/Images/loginLogo.png";
import "./SignUp.css";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";
import { auth, googleProvider, signInWithPopup } from "utils/firebase";
import { Spin } from "antd";
import { FcGoogle } from "react-icons/fc";
import SEO from "component/SEO/SEO";

const SignUp = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const email =
        user.email ||
        result.providerData?.[0]?.email ||
        result._tokenResponse?.email ||
        null;

      if (!email) {
        showErrorToast("Unable to retrieve email from Google account");
        setLoading(false);
        return;
      }

      const payload = {
        googleId: user.uid,
        email: email,
        displayName: user.displayName || email.split('@')[0],
        image: user.photoURL || "",
        fcmToken: "fcm-token",
      };

      console.log("Final Payload:", payload);

      const response = await Service.GoogleLogin(payload);

      if (response && response.data) {
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("userEmail", email);
        localStorage.setItem("userName", user.displayName || email.split('@')[0]);
        
        showSuccessToast("Google login successful!");
        
        setTimeout(() => {
          navigate("/");
        }, 1000);
      } else {
        showErrorToast("Login failed. Please try again.");
      }
    } catch (error) {
      console.error("Error during Google login:", error);
      
      if (error.code === 'auth/popup-closed-by-user') {
        showErrorToast("Login cancelled. Please try again.");
      } else if (error.code === 'auth/popup-blocked') {
        showErrorToast("Popup blocked. Please allow popups for this site.");
      } else if (error.code === 'auth/network-request-failed') {
        showErrorToast("Network error. Please check your connection.");
      } else {
        showErrorToast("Failed to login with Google. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <SEO title="Sign In" noindex={true} />
    <div className="signup-container">
      <div className="signup-card">
        <div className="signup-logo-section">
          <img src={loginLogo} alt="Vers Attire Logo" className="signup-logo" />
        </div>
        
        <div className="signup-content">
          <h1 className="signup-header">Welcome Back!</h1>
          <p className="signup-subheader">Sign in to continue shopping</p>
          
          <button 
            className="signup-google-button" 
            onClick={handleGoogleLogin}
            disabled={loading}
          >
            {loading ? (
              <Spin size="small" />
            ) : (
              <>
                <FcGoogle className="signup-google-icon" />
                <span>Continue with Google</span>
              </>
            )}
          </button>

          <div className="signup-divider">
            <span className="divider-line"></span>
            <span className="divider-text">Secure Login</span>
            <span className="divider-line"></span>
          </div>

          <div className="signup-features">
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Fast & Secure Checkout</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Order Tracking</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Exclusive Offers</span>
            </div>
          </div>

          <p className="signup-terms">
            By continuing, you agree to Vers Attire's{" "}
            <Link to="/terms" className="signup-link">
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link to="/privacy" className="signup-link">
              Privacy Policy
            </Link>
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default SignUp;